<template>
  <MainLayout>
    <template #content>
      <ValidationObserver
        v-slot="{ handleSubmit }"
        class="content-container flex flex-col w-full h-full items-center"
      >
        <form
          class="container w-full flex flex-col items-center"
          @submit.prevent="handleSubmit(onSubmit)"
        >
          <div class="font-bold py-2 text-2xl md:text-4xl font-display mb-1 text-gray-900">
            Registrieren
          </div>

          <div class="flex flex-col w-full md:w-1/2 my-5">
            <ProfileForm
              type="user"
              :errorMessages="errorMessages"
              @onChange="onChange"
            />
            <SettingsForm
              :errorMessages="errorMessages"
              @onChange="onChange"
            />

            <div class="flex flex-col w-full mb-2">
              <div class="text-sm">Code</div>
              <input
                v-if="isTourism"
                type="text"
                v-model="form.code"
                class="input-field mt-2 px-3 text-sm py-2"
              >
            </div>

            <CheckboxField
              id="dataPrivacy"
              v-model="form.dataPrivacy"
              container="mb-0"
              :rules="{ required: { allowFalse: false } }"
            >
              <template #labelSentence_>
                <label class="text-xs px-1 py-0 mt-0 font-bold text-gray-900 font-body">
                  Ich akzeptiere die
                  <a
                    class="text-peach underline"
                    href="https://about.epasnets.com/datenschutz/"
                    target="_blank"
                  >
                    Datenschutzerklärung.
                  </a>
                </label>
              </template>
            </CheckboxField>
            <CheckboxField
              id="terms"
              v-model="form.terms"
              type="text"
              container="mb-2"
              :rules="{ required: { allowFalse: false } }"
            >
              <template #labelSentence_>
                <label class="text-xs px-1 py-0 mt-0 font-bold text-gray-900 font-body">
                  Ich akzeptiere die
                  <a
                    class="text-peach underline"
                    href="https://about.epasnets.com/agb/"
                    target="_blank"
                  >
                    Nutzungsbedingungen.
                  </a>
                </label>
              </template>
            </CheckboxField>
          </div>
          <div class="w-full sm:w-1/2 mb-3">
            <Button
              v-if="!isTourism"
              class="flex flex-col items-center w-full"
              type="submit"
              label="Kostenlos registrieren"
              size="w-full py-3"
              round="rounded"
            />
            <Button
              v-else
              class="flex flex-col items-center w-full"
              type="submit"
              label="Kostenlos registrieren"
              size="w-full py-3"
              round="rounded"
              :disabled="isValidCode"
            />
          </div>
        </form>
      </ValidationObserver>
    </template>
  </MainLayout>
</template>
<script>
  import MainLayout from '_layouts/subdomain';
  import Button from '_components/Button';
  import RegisterTabs from '_components/Modules/Register/Tabs'
  import ProfileForm from '_components/Modules/Profile/Form/ProfileForm';
  import SettingsForm from '_components/Modules/Profile/Form/SettingsForm';
  import CheckboxField from '_components/Form/CheckboxField';

  export default {
    name: 'Register',
    components: {
      MainLayout,
      ProfileForm,
      SettingsForm,
      Button,
      RegisterTabs,
      CheckboxField
    },
    data() {
      return {
        submitting: false,
        errorMessages: [],
        form: {
          role_id: 3,
          region_id: null,
          username: '',
          firstName: '',
          lastName: '',
          email: '',
          address: '',
          city: '',
          zip_code: '',
          phone_number: '',
          password: '',
          confirmPassword: '',
          dataPrivacy: false,
          terms: false,
          subdomain: '',
          code: ''
        },
        isTourism: false,
        isValidCode: false
      }
    },
    computed: {
      AUTH_USER()
      {
        return this.$store.getters.AUTH_USER
      }
    },
    watch: {
    },
    created() {
      this.isTourism = this.wildcard === 'oetztal' ? true : false
    },
    methods: {
      async onSubmit()
      {
        try {
          this.errorMessages = []
          await this.$store.commit('SET_IS_PROCESSING', { status: 'open' })
          localStorage.setItem('cart', this.$store.getters.COUNT_CART)
          this.form.subdomain = this.wildcard
          const { token, user } = await this.$store.dispatch('ADD_USER', this.form)
          console.l
          await this.setLoginAuth(token, user)
          this.$router.go('home')
          // this.$swal({
          //   icon: 'success',
          //   title: 'Erfolgreich!',
          //   text: data.message,
          //   showCancelButton: false,
          //   allowOutsideClick: false,
          //   confirmButtonColor: '#48BB78',
          //   confirmButtonText: 'Bestätigen',
          // }).then(async (result) => {
          //   if(result.value){

          //   }
          // })
          // this.$swal({
          //   icon: 'success',
          //   title: 'Erfolgreich!',
          //   text: 'Creating an account.',
          //   confirmButtonColor: '#48BB78',
          // })
        } catch (err) {
          if( err?.response?.status == 422 ) {
            this.errorMessages = err.response.data.errors
          }

          if(err?.response?.status == 404) {
            const message = err?.response?.data?.message

            this.$swal({
              icon: 'error',
              text: message,
              allowOutsideClick: false,
            })
          }
          
          await this.$store.commit('SET_IS_PROCESSING', { status: 'close' })
        }
      },
      onChange( data )
      {
        this.form = {
          ...this.form,
          ...data
        }
      },
      async setLoginAuth(token, user){
        const auth = {
          isAuth: true,
          token,
          data: user,
          role: user.user_role.role
        }
        await localStorage.removeItem('_auth')
        await localStorage.setItem('_auth', JSON.stringify(auth))
        await this.$store.commit('SET_AUTH_USER', auth)
      },
    }
  }
</script>
<style lang='css' scoped>
  @media only screen and (max-width: 599px) {
    .container {
      width: 90% !important;
    }
  }
  @media only screen and (max-width: 767px) {
    .container {
      width: 60%;
    }
  }
  @media only screen and (min-width: 768px) and (max-width: 991px) {
    .container {
      width: 50%;
    }
  }
</style>